import { getDocumentoPendienteValidacionById } from "features/Documentos/redux/documentosExtraActions"

export function docPendienteValidacionParams({
  dispatch,
  service,
  id,
}: $TSMigrationFixMe) {
  // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
  dispatch(getDocumentoPendienteValidacionById({ service, id }))
}
